import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { MessageCircle } from "lucide-react";

// Reusable WhatsApp quick-action: lets the pro edit the message before opening wa.me.
export default function WhatsAppButton({ phone, context = {}, size = "sm", variant = "outline", label = "WhatsApp" }) {
  const [open, setOpen] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [msg, setMsg] = useState("");

  useEffect(() => { if (open) api.get("/comm-templates").then((r) => setTemplates((r.data || []).filter((t) => t.channel === "whatsapp"))).catch(() => {}); }, [open]);

  const applyTpl = (t) => {
    let b = t.body || "";
    Object.entries(context).forEach(([k, v]) => { b = b.replaceAll(`{{${k}}}`, v || ""); });
    setMsg(b);
  };
  const send = () => {
    const num = (phone || "").replace(/[^0-9]/g, "");
    const url = `https://wa.me/${num}?text=${encodeURIComponent(msg)}`;
    window.open(url, "_blank");
    setOpen(false);
  };

  return (
    <>
      <Button size={size} variant={variant} onClick={() => setOpen(true)} data-testid="whatsapp-btn" className="border-emerald-500/30 text-emerald-600">
        <MessageCircle className="w-4 h-4 mr-1.5" /> {label}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-white border-slate-200 max-w-md">
          <DialogHeader><DialogTitle>Message WhatsApp</DialogTitle></DialogHeader>
          <div className="space-y-3">
            {templates.length > 0 && (
              <Select onValueChange={(id) => { const t = templates.find((x) => x.id === id); if (t) applyTpl(t); }}>
                <SelectTrigger data-testid="wa-template" className="bg-slate-50 border-slate-200"><SelectValue placeholder="Choisir un modèle" /></SelectTrigger>
                <SelectContent className="bg-white border-slate-200">{templates.map((t) => <SelectItem key={t.id} value={t.id}>{t.name}</SelectItem>)}</SelectContent>
              </Select>
            )}
            <Textarea rows={5} value={msg} onChange={(e) => setMsg(e.target.value)} data-testid="wa-message" placeholder="Votre message (modifiable avant envoi)…" className="bg-slate-50 border-slate-200" />
            {!phone && <p className="text-xs text-amber-600">Aucun numéro de téléphone pour ce contact.</p>}
          </div>
          <DialogFooter>
            <Button variant="ghost" onClick={() => setOpen(false)}>Annuler</Button>
            <Button onClick={send} disabled={!phone || !msg.trim()} data-testid="wa-send" className="bg-emerald-500 hover:bg-emerald-600 text-black font-semibold">Ouvrir WhatsApp</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
